var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigurIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 70.5,
    fill: "white",
    stroke: "#F0EEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 90.2807C76.797 85.7486 80.5234 78.6903 80.5234 70.7617C80.5234 62.8331 76.797 55.7748 71 51.2428C75.2019 47.9578 80.4915 46 86.2384 46C99.9139 46 111 57.0862 111 70.7617C111 84.4372 99.9139 95.5234 86.2384 95.5234C80.4915 95.5234 75.2019 93.5656 71 90.2807ZM71 90.2807C66.7982 93.5656 61.5086 95.5234 55.7617 95.5234C42.0862 95.5234 31 84.4372 31 70.7617C31 57.0862 42.0862 46 55.7617 46C61.5086 46 66.7982 47.9578 71 51.2428C65.2031 55.7748 61.4767 62.8331 61.4767 70.7617C61.4767 78.6903 65.2031 85.7486 71 90.2807Z",
    fill: "#F5C000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 51.2428C65.2031 55.7748 61.4767 62.8331 61.4767 70.7617C61.4767 78.6903 65.2031 85.7486 71 90.2807C66.7982 93.5656 61.5086 95.5234 55.7617 95.5234C42.0862 95.5234 31 84.4372 31 70.7617C31 57.0862 42.0862 46 55.7617 46C61.5086 46 66.7982 47.9578 71 51.2428Z",
    fill: "#00A890"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurIcon);
export default __webpack_public_path__ + "static/media/configur-icon.d3bf2b3cda74c8f0751c9c2d71293d0a.svg";
export { ForwardRef as ReactComponent };